export default "__VITE_ASSET__AJY6yyg$Az2Wip$zwfNegg__"